module.exports = __webpack_public_path__ + "static/hunger_spanish-2f2b341b491b6b28445605d963be4404.png";